import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { useEHRContext } from 'contexts/EHRContext';
import './Modals.css';
import { useHistory } from 'react-router-dom';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { useUserContext } from 'store';

export function OrganizationAccess({
  isOpen, organization, patient, openModalEmergency, preSelect,
}) {
  const [user] = useUserContext();
  const [isListOpen, setIsListOpen] = useState(false);
  const [selectOrganization, setSelectOrganization] = useState(preSelect.name || '');
  const { setPatient } = useEHRContext();
  const [organizationID, setOrganizationID] = useState(preSelect.cnes || '');
  const history = useHistory();

  return (

    <Dialog
      className="organizationAccessModal"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Acessar
        <button onClick={() => isOpen(false)} className="br-button close circle small" type="button" data-dismiss="br-modal" aria-label="Close">
          <i className="fas fa-times" aria-hidden="true" />
        </button>

      </DialogTitle>

      <DialogContent>
        <div className="organizationAccessModal-text">
          <p> Selecione a organização para realizar o acesso </p>
        </div>

        <div className="col">
          <div className="br-select">
            <div className="br-input">
              <input id="select-simple" type="text" value={selectOrganization} placeholder="Selecione o item" onClick={() => setIsListOpen(!isListOpen)} />
              <button onClick={() => setIsListOpen(!isListOpen)} className="br-button" type="button" aria-label="Exibir lista">
                {!isListOpen
                  ? <FaCaretDown />
                  : <FaCaretUp />}
              </button>
            </div>
            {isListOpen
              ? (
                <div className="organizationAccessModal br-list" style={{ display: 'block' }}>
                  {
                    organization
                    && (
                      <>
                        {organization.map((option, index) => {
                          const disableOption = !user.userData.rolesPerOrganization.find((rolesElement) => (
                            rolesElement.id === (option.cnes)
                          ));
                          return (
                            <div
                              key={`organizationOption-${index}`}
                              className="br-item"
                              hidden={disableOption}
                            >
                              <div className="br-radio">
                                <input
                                  onClick={(e) => setIsListOpen(!isListOpen) & setSelectOrganization(e.target.value) & setOrganizationID(option.cnes
                                    ? option.cnes
                                    : 'Não Encontrado')}
                                  id={`rb${index}`}
                                  type="radio" name="gender-options"
                                  value={option.name
                                    ? option.name
                                    : 'Não Encontrado'}
                                />
                                <label htmlFor={`rb${index}`}>
                                  {option.name
                                    ? option.name
                                    : 'Não Encontrado'}
                                </label>
                              </div>
                            </div>

                          );
                        })}
                      </>
                    )
                  }
                </div>
              )
              : <></>}

          </div>
        </div>
      </DialogContent>
      <DialogActions className="modalResponsive">
        <button
          className="br-button danger small m-2 buttonEmergency responsiveAjust" type="button"
          onClick={() => isOpen(false) & openModalEmergency(true)}
        >
          Acesso de emergência
        </button>
        <button onClick={() => isOpen(false)} className="organizationAccessModal-closeButton" type="button">
          Cancelar
        </button>
        <button
          disabled={selectOrganization === ''}
          className="organizationAccessModal-selectButton" type="button"
          onClick={() => {
            setPatient({
              resourceId: patient.patientIdentifier,
              organizationId: organizationID || 'Não Encontrado',
              purposeOfUse: 'Atendimento',
            });
            history.push('/registros');
          }}
        >
          Continuar
        </button>
      </DialogActions>
    </Dialog>
  );
}
OrganizationAccess.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  organization: PropTypes.element.isRequired,
  patient: PropTypes.element.isRequired,
  openModalEmergency: PropTypes.element,
  preSelect: PropTypes.element,

};
OrganizationAccess.defaultProps = {
  openModalEmergency: false,
  preSelect: {},
};
